import React from 'react';
import { Box, Heading, Text, Button, Flex, VStack, Icon, Image, Divider } from '@chakra-ui/react';
import { WarningTwoIcon } from '@chakra-ui/icons';
import { MdRefresh, MdSupportAgent } from 'react-icons/md';
import logoTotolac from 'assets/img/profile/logo.png';

const Fail: React.FC = () => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgGradient="linear(to-br, #f8f9fa, #e9ecef)"
      p={4}
    >
      <Box
        textAlign="center"
        p={8}
        maxW="600px"
        w="100%"
        borderRadius="2xl"
        bg="white"
        boxShadow="2xl"
        border="1px solid"
        borderColor="gray.200"
      >
        {/* Logo de Totolac */}
        <Flex justify="center" mb={6}>
          <Image
            src={logoTotolac}
            alt="Logo Totolac"
            h="100px"
            objectFit="contain"
          />
        </Flex>

        {/* Icono de error */}
        <Icon
          as={WarningTwoIcon}
          w={20}
          h={20}
          color="red.500"
          mb={4}
        />

        {/* Título */}
        <Heading
          as="h2"
          size="2xl"
          mb={4}
          bgGradient="linear(to-r, #dc2626, #b91c1c)"
          bgClip="text"
          fontWeight="bold"
        >
          Pago Fallido
        </Heading>

        <Divider mb={6} borderColor="gray.300" />

        {/* Mensaje principal */}
        <VStack spacing={4} mb={6}>
          <Text fontSize="lg" color="gray.700" fontWeight="medium">
            Algo salió mal durante el proceso de pago.
          </Text>

          {/* Información adicional */}
          <Box
            p={4}
            bg="orange.50"
            borderRadius="lg"
            border="1px solid"
            borderColor="orange.200"
            w="100%"
          >
            <Flex align="center" justify="center" mb={2}>
              <Icon as={MdSupportAgent} w={5} h={5} color="orange.600" mr={2} />
              <Text fontSize="md" fontWeight="semibold" color="orange.800">
                ¿Necesitas ayuda?
              </Text>
            </Flex>
            <Text fontSize="sm" color="gray.600">
              Si el problema persiste, por favor contacta a soporte técnico o visita las oficinas de atención al ciudadano.
            </Text>
          </Box>

          <Text fontSize="md" color="gray.600" mt={2}>
            Por favor, verifica tu información e inténtalo de nuevo.
          </Text>
        </VStack>

        <Divider mb={6} borderColor="gray.300" />

        {/* Botones de acción */}
        <VStack spacing={3} w="100%">
          <Button
            bgGradient="linear(to-r, #681a2d, #5b182b)"
            color="white"
            size="lg"
            w="100%"
            leftIcon={<MdRefresh />}
            _hover={{
              bgGradient: "linear(to-r, #7a1f36, #6c1e33)",
              transform: "translateY(-2px)",
              boxShadow: "lg"
            }}
            _active={{
              bgGradient: "linear(to-r, #5a1625, #4d1523)"
            }}
            transition="all 0.2s"
            onClick={() => window.location.assign('https://portalciudadano.totolac.gob.mx/')}
          >
            Volver al Inicio
          </Button>

          <Button
            variant="outline"
            colorScheme="gray"
            size="lg"
            w="100%"
            onClick={() => window.history.back()}
          >
            Regresar
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
};

export default Fail;
